import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

const base = "w-full bg-surface-2 border border-border rounded-md pl-4 pr-11 py-3 text-fg text-sm focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent/40 transition-shadow";

export default function PasswordInput({ value, onChange, placeholder = "••••••••", testid, minLength, required }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        className={base}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-accent p-1"
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        tabIndex={-1}
      >
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
